import Img401PageNotFound from 'Assets/Images/img_401.svg';
import Img403PagForbidden from 'Assets/Images/img_403.svg';
import Img404PageNotFound from 'Assets/Images/img_404.svg';
import Img408RequestTimeOut from 'Assets/Images/img_408.svg';
import Img500InternalServerError from 'Assets/Images/img_500.svg';
import Img503SomethingWrong from 'Assets/Images/img_503.svg';
import Img504SiteCantAccess from 'Assets/Images/img_504.svg';
import { GetSsoSignoutURL, GetTalentaURL } from 'Helpers';

export default {
    '401': {
        imagePath: Img401PageNotFound,
        altImage: 'No Authorization',
        titleContent: 'No authorization',
        paragraphContent: <>Access is allowed only for registered users.<br/>Contact your HR Admin to get the access.</>,
        linkTo: GetSsoSignoutURL(),
        linkLabel: 'Login'
      },
      '403': {
        imagePath: Img403PagForbidden,
        altImage: 'Access Denied',
        titleContent: 'Access denied',
        paragraphContent: <>You don`t have permission to access this page.<br/>Contact your HR Admin to get the access.</>,
        linkTo: '',
        linkLabel: '' // REQUEST ACCESS
      },
      '404': {
        imagePath: Img404PageNotFound,
        altImage: 'Page Not Found',
        titleContent: 'Page not found',
        paragraphContent: <>Please check the URL and try again.</>,
        linkTo: GetTalentaURL(),
        linkLabel: 'Back to Talenta'
      },
      '408': {
        imagePath: Img408RequestTimeOut,
        altImage: 'Request Time Out',
        titleContent: 'Request time out',
        paragraphContent: <>This request takes too long to process. Please reload this page.</>,
        linkTo: '/',
        linkLabel: 'Reload'
      },
      '500': {
        imagePath: Img500InternalServerError,
        altImage: 'Internal Server Error',
        titleContent: 'Internal server error.',
        paragraphContent: <>Please try again later.</>,
        linkTo: GetTalentaURL(),
        linkLabel: 'Back to Talenta'
      },
      '503': {
        imagePath: Img503SomethingWrong,
        altImage: 'Something Went Wrong',
        titleContent: 'Something went wrong',
        paragraphContent: <>We are working on fixing the problem. Please try again later.</>,
        linkTo: GetTalentaURL(),
        linkLabel: 'Back to Talenta'
      },
      '504': {
        imagePath: Img504SiteCantAccess,
        altImage: 'Site Can`t Access',
        titleContent: 'This site can`t be access for now',
        paragraphContent: <>Refresh your page or try again later.</>,
        linkTo: '/',
        linkLabel: 'Refresh'
      },
}